import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './routes';
import store from "@/store/store";

Vue.use(Router)

// 配置路由
const RouterConfig = {
  routes:routes
}

// 创建VueRouter 实例
export const router = new Router(RouterConfig)

/**
 * to 下一个页面
 * from 从那个页面来
 * next 到哪里去
 */
router.beforeEach((to, from, next) => {
  var data = sessionStorage.getItem('isLogin');

  /*if(data){
    // 已经登录的判断
    data = JSON.parse(data);

    if(data.time <= new Date().getTime()){
      Vue.prototype.$message.warning('登录过期，请重新登录后操作！');

      /!*if(to.path !== "/login"){
        // 未登录则跳转到登陆界面，query:{ Rurl: to.fullPath}表示把当前路由信息传递过去方便登录后跳转回来；
        next({path: '/login', query:{ Rurl: to.fullPath} });  // 跳转至登录界面
      }else{
        next();
      }*!/
      if(to.path !== "/account") {
        next({path: '/home', query:{ Rurl: to.fullPath} });  // 跳转至登录界面
      }
    }else{
      sessionStorage.setItem("isLogin", JSON.stringify({
        token: data.token,
        time: new Date().getTime() + 30 * 60 * 1000
      }));

      next();  // 跳转至
    }
  }*/

  /*if(!data){
    // Vue.prototype.$message.warning('检测到您还未登录,请登录后操作！');

    console.log("topath", to);
    if(to.path !== "/home"){
      next({path: '/home', query:{ Rurl: to.fullPath} });  // 跳转至登录界面
    }else{
      next();
    }
  }*/

  /* 路由发生变化修改页面title */
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  next();
  switch (to.name) {
    case "Home":{
      store.state.mainMenu.activeName = "01";
      store.state.title = "";
      break;
    }
    case "Information":{
      store.state.mainMenu.activeName = "02";
      store.state.title = "资讯中心";
      store.state.path = "/Information";
      store.state.mainMenu2.activeName = '02';
      break;
    }
    case "Flow":{
      store.state.mainMenu.activeName = "03";
      store.state.mainMenu3.activeName = "01";
      store.state.mainMenu3.list_class = "";
      store.state.title = "电子保险保函";
      store.state.path = "/InsuranceGuarantee";
      break;
    }
    case "Concept":{
      store.state.mainMenu.activeName = "03";
      store.state.mainMenu3.activeName = "02";
      store.state.mainMenu3.list_class = "";
      store.state.title = "电子保险保函";
      store.state.path = "/InsuranceGuarantee";
      break;
    }
    case "Advantage":{
      store.state.mainMenu.activeName = "03";
      store.state.mainMenu3.activeName = "03";
      store.state.mainMenu3.list_class = "nav-list2";
      store.state.title = "电子保险保函";
      store.state.path = "/InsuranceGuarantee";
      break;
    }
    case "BankGuarantee":{
      store.state.mainMenu.activeName = "04";
      store.state.title = "电子银行保函";
      store.state.path = "/BankGuarantee";
      break;
    }
    case "AboutUs":{
      store.state.mainMenu.activeName = "05";
      store.state.title = "关于我们";
      store.state.path = "/AboutUs";
      break;
    }
    case "Introduce":{
      store.state.mainMenu.activeName = "05";
      store.state.title = "关于我们";
      store.state.mainMenu4.activeName = "01";
      store.state.path = "/AboutUs";
      break;
    }
    case "Development":{
      store.state.mainMenu.activeName = "05";
      store.state.title = "关于我们";
      store.state.mainMenu4.activeName = "02";
      store.state.path = "/AboutUs";
      break;
    }
    case "Organization":{
      store.state.mainMenu.activeName = "05";
      store.state.title = "关于我们";
      store.state.mainMenu4.activeName = "03";
      store.state.path = "/AboutUs";
      break;
    }
  }

})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0); // 滚动到顶部
  // 或
  // window.scroll(0, 0);
});



// WEBPACK FOOTER //
// ./src/router/index.js